/**
 * New Arrivals row (sections/new-arrivals.liquid) when no collection is picked.
 * Liquid can only see the first 50 products of the catalog, so it can't tell which are newest. This asks the
 * Shop Products page, sorted newest first, and swaps its first few product cards into the carousel track.
 */
class NewestProducts extends HTMLElement {
  async connectedCallback() {
    const limit = parseInt(this.dataset.limit, 10) || 8;
    const track = this.querySelector('[data-review-track]');
    if (!track) return;
    try {
      const response = await fetch(this.dataset.url, { headers: { 'X-Requested-With': 'fetch' } });
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const items = [...doc.querySelectorAll('.catalog__grid > li')].slice(0, limit);
      if (!items.length) return;

      track.replaceChildren();
      items.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'new-arrivals__item';
        const card = document.importNode(item, true);
        card.querySelector('.product-card__sku')?.remove();
        if (this.dataset.showVendor !== 'true') card.querySelector('.product-card__vendor')?.remove();
        li.append(...card.childNodes);
        track.appendChild(li);
      });
      // Arrows only show when more than four cards are in the row.
      const arrows = this.querySelector('.new-arrivals__arrows');
      if (arrows) arrows.hidden = items.length <= 4;
    } catch (error) {
      // Leave whatever the page rendered.
    }
  }
}
if (!customElements.get('newest-products')) customElements.define('newest-products', NewestProducts);
